var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto py-8"},[_c('div',{staticClass:"space-y-10"},[_c('GasSaverNotice'),_c('PendleStakingSection'),_c('YtOtStakingSection'),_c('hr',{staticClass:"!mt-20 block"}),_c('OldOtStakingPoolSection')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }